// Gestion des coefficients par département
interface DepartmentCoefficient {
  code: string;
  name: string;
  coefficient: number;
}

// Coefficients par défaut pour chaque région
const defaultCoefficients: Record<string, number> = {
  'ILE_DE_FRANCE': 1.2,
  'PACA': 1.15,
  'AUVERGNE_RHONE_ALPES': 1.1,
  'OCCITANIE': 1.05,
  'NOUVELLE_AQUITAINE': 1.05,
  'GRAND_EST': 1,
  'HAUTS_DE_FRANCE': 1,
  'NORMANDIE': 1,
  'BRETAGNE': 1,
  'PAYS_DE_LA_LOIRE': 1,
  'CENTRE_VAL_DE_LOIRE': 0.95,
  'BOURGOGNE_FRANCHE_COMTE': 0.95
};

// Mapping des départements vers leur région
const departmentRegionMapping: Record<string, keyof typeof defaultCoefficients> = {
  '75': 'ILE_DE_FRANCE',
  '77': 'ILE_DE_FRANCE',
  '78': 'ILE_DE_FRANCE',
  // ... ajouter tous les départements
};

export const getDepartmentCoefficient = (departmentCode: string): number => {
  const region = departmentRegionMapping[departmentCode];
  return region ? defaultCoefficients[region] : 1;
};